module.exports = __webpack_public_path__ + "img/address-book.0ec034af.svg";